define([], function () {
    'use strict';

    /**
     * format time to hh:mm:ss
     * Loosely based on https://jsperf.com/ms-to-hh-mm-ss-time-format
     * @param {number} sec seconds to convert
     * @param {number} [maxSec] upper limit for seconds to format and show
     * @returns {string} hh:mm:ss
     */
    function getReadableTime(sec, maxSec) {
        if (maxSec) {
            sec %= maxSec;
        }
        const date = new Date(sec * 1000);

        const hours = date.getUTCHours();
        let minutes = date.getUTCMinutes();
        let seconds = date.getUTCSeconds();

        if (seconds < 10) {
            seconds = `0${seconds}`;
        }

        if (hours) {
            if (minutes < 10) {
                minutes = `0${minutes}`;
            }
            return `${hours}:${minutes}:${seconds}`;
        }
        return `${minutes}:${seconds}`;
    }


    return {
        getReadableTime
    };
});
